import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ExpertPicker from "../../expert_picker/ExpertPicker";
import SelectedExperts from "../../expert_picker/SelectedExperts";
import { MIN_EXPERTS, MAX_EXPERTS } from "../../expert_picker/constants";

// The "Experts" subsection of StoryIdeaForm: label + tooltip, the selected
// expert cards, the picker, and the validation error. Presentational —
// selection state, hydration and merge policy live in the useSelectedExperts
// hook owned by the parent form (so the form's reset flows can reach it).
//
// Symmetric to the future <RecipientsField> / <ScheduleField> etc. so each
// stacked card extends its own focused file rather than this form.
export default function ExpertsField({
  selected,
  publishabilityById,
  atMax,
  onAdd,
  onRemove,
  onSuggest,
  onClear,
  error,
}) {
  return (
    <div className="mb-3">
      {/* Section heading for a composite widget (cards + picker), not a
          single labelable control — a <div>, not a <label>. */}
      <div className="form-label">
        Experts <span className="text-danger">*</span>
        <OverlayTrigger
          key="right"
          placement="right"
          overlay={
            <Tooltip id="tooltip-experts">
              Select {MIN_EXPERTS}–{MAX_EXPERTS} experts to feature in the email. Search by text (semantic) or by name.
            </Tooltip>
          }
        >
          <i className="fa-solid fa-circle-info text-muted ms-1" style={{ fontSize: "0.8em" }} title="info" />
        </OverlayTrigger>
      </div>
      <SelectedExperts experts={selected} publishabilityById={publishabilityById} onRemove={onRemove} />
      <ExpertPicker selectedExperts={selected} atMax={atMax} onAdd={onAdd} onSuggest={onSuggest} onClear={onClear} />
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
}
